import { styled } from "@mui/material/styles";
import { Drawer, List, ListItem } from "@mui/material";

export const ListItemTopMenuWrapper = styled(ListItem)(({ theme }) => ({
  padding: 0,
  "&:hover": {
    backgroundColor: theme.palette.grey[300], // Highlight color on hover
  },
}));

export const ListItemSubMenuWrapper = styled(List)(({ theme }) => ({
  padding: 0,
  paddingLeft: 16,
  "&:hover": {
    backgroundColor: theme.palette.grey[200], // Highlight color on hover
  },
  "& ul": {
    padding: 0,
  },
}));

export const DrawerWrapper = styled(Drawer)(() => ({
  width: 240, // Set drawer width
  flexShrink: 0, // Prevent shrinking
  "& .MuiDrawer-paper": {
    width: 240, // Drawer paper width
    boxSizing: "border-box", // Ensures padding and border are included in width/height
  },
}));
